import { render, staticRenderFns } from "./C2ctTable.vue?vue&type=template&id=4f862064&scoped=true&"
import script from "./C2ctTable.vue?vue&type=script&lang=js&"
export * from "./C2ctTable.vue?vue&type=script&lang=js&"
import style0 from "./C2ctTable.vue?vue&type=style&index=0&id=4f862064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f862064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f862064')) {
      api.createRecord('4f862064', component.options)
    } else {
      api.reload('4f862064', component.options)
    }
    module.hot.accept("./C2ctTable.vue?vue&type=template&id=4f862064&scoped=true&", function () {
      api.rerender('4f862064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/C2ctTable.vue"
export default component.exports